var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex my-auto  justify-center"},[_c('v-img',{staticClass:"mt-n4 ma-auto",staticStyle:{"object-fit":"cover"},attrs:{"max-height":"20%","max-width":"20%","src":require("@/assets/coloring_logo.png")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }